var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EditSelect } from 'shared/assets/icons';
import { Button, Select, Box, Icon } from '../../ui';
export var PageSelect = function (_a) {
    var label = _a.label, isReadOnly = _a.isReadOnly, name = _a.name, register = _a.register, rules = _a.rules, selectProps = __rest(_a, ["label", "isReadOnly", "name", "register", "rules"]);
    return (_jsxs(Box, __assign({ role: "group" }, { children: [_jsx(Select, __assign({ width: "auto", variant: "pageSelect", isReadOnly: isReadOnly, zIndex: 1 }, selectProps, (register && register(name, rules)), { icon: _jsx(_Fragment, {}) })), !isReadOnly && (_jsxs(Button, __assign({ mt: -14, p: 0, pt: 1, variant: "links", _groupHover: {
                    color: 'green.600',
                } }, { children: [label, " ", _jsx(Icon, { boxSize: 4, as: EditSelect })] })))] })));
};
